import { useNavigate } from 'react-router-dom';
import { Menu as MenuIcon } from 'lucide-react';
import { useAuth } from '@/features/auth/hooks/use-auth';
import { Menu, MenuItem, MenuSeparator } from '@/shared/components/overlay/Menu';
import { ThemeToggle } from '@/app/layout/ThemeToggle';

export interface AppTopbarProps {
  /** Ouvre le tiroir de navigation (mobile < lg). */
  readonly onMenuClick: () => void;
}

export function AppTopbar({ onMenuClick }: AppTopbarProps) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate('/login', { replace: true });
  }

  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-4 border-b border-hairline bg-canvas/90 px-4 backdrop-blur lg:px-8">
      <button
        type="button"
        onClick={onMenuClick}
        aria-label="Ouvrir le menu"
        className="grid size-11 shrink-0 place-items-center rounded-sm text-ink transition-colors hover:bg-surface-3 hover:text-ink focus-visible:outline-accent lg:hidden"
      >
        <MenuIcon aria-hidden="true" className="size-5" strokeWidth={1.75} />
      </button>

      <div className="ml-auto flex items-center gap-3">
        <ThemeToggle />
        <Menu
          label="Menu utilisateur"
          buttonClassName="inline-flex items-center gap-2 rounded-sm border border-hairline bg-surface px-3 py-1.5 transition-colors hover:bg-surface-3"
          trigger={
            <>
              <span className="grid size-7 place-items-center rounded-sm bg-accent text-metadata font-semibold text-on-accent">
                {(user?.email ?? '?').charAt(0).toUpperCase()}
              </span>
              <span className="text-metadata font-medium text-ink">{user?.email}</span>
            </>
          }
        >
          <MenuItem onSelect={handleLogout} danger>
            Se déconnecter
          </MenuItem>
          <MenuSeparator />
          <p className="px-3 py-1.5 text-metadata text-ink-faint">Espace client</p>
        </Menu>
      </div>
    </header>
  );
}
